import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageLoader, formatDate } from "@/components/common";
import { MessageCircle, ArrowRight } from "lucide-react";

export default function Messages() {
    const { data } = useQuery({ queryKey: ["message-rooms"], queryFn: async () => (await api.get("/me/messages")).data });
    if (!data) return <PageLoader />;

    return (
        <div className="space-y-6">
            <h1 className="font-display text-2xl font-700 tracking-tight text-primary">Messages</h1>
            <p className="-mt-3 text-sm text-muted-foreground">Temporary group chats for your outings. They close automatically after each event.</p>
            {data.length === 0 && (
                <div className="flex flex-col items-center rounded-2xl bg-card p-10 text-center shadow-sm">
                    <MessageCircle className="h-10 w-10 text-accent" />
                    <p className="mt-3 font-600 text-primary">No group chats yet</p>
                    <p className="mt-1 text-sm text-muted-foreground">Once you confirm an outing, your group chat appears here.</p>
                </div>
            )}
            <div className="space-y-3">
                {data.map((r) => (
                    <Link key={r.outing_id} to={`/outings/${r.outing_id}?tab=chat`} data-testid={`message-room-${r.outing_id}`}>
                        <div className="flex items-center gap-4 rounded-2xl bg-card p-5 shadow-sm">
                            <div className="grid h-12 w-12 flex-none place-items-center rounded-2xl bg-secondary text-xl">{r.activity_emoji}</div>
                            <div className="min-w-0 flex-1">
                                <div className="flex items-center gap-2">
                                    <p className="truncate font-600 text-primary">{r.activity_name}</p>
                                    {r.status !== "open" && <span className="rounded-full bg-muted px-2 py-0.5 text-[10px] font-700 uppercase text-muted-foreground">closed</span>}
                                </div>
                                <p className="truncate text-sm text-muted-foreground">{r.last_message || "No messages yet"}</p>
                            </div>
                            <ArrowRight className="h-5 w-5 text-muted-foreground" />
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
